import {
  Button,
  Card,
  Flex,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Space,
} from 'antd'
import { useState } from 'react'
import { ScanCenterCode } from '~app/graph/generated/graphql'
import i18n from '~app/i18n/i18n'

enum FilterOptions {
  Equals = 'Equals',
  NotEquals = 'Not Equals',
}

const scanCenters = Object.values(ScanCenterCode)

export interface InboxFiltersProps {
  tagger?: string
  documentsCount: number
  batchSize: number
  taggerFiltered: boolean
  onAssignDocumentsToTagger: () => Promise<void>
  onBatchSize: (batchSize: number) => void
  onTaggerFilter: (tagger: boolean) => void
  onSetCustomerId: (customerId: string) => void
  customerId: string
  scancenterId: ScanCenterCode
  onSetScancenterId: (scancenterId: ScanCenterCode) => void
  excludeScanCenter: boolean
  excludeCustomerId: boolean
  onToggleExcludeScanCenter: VoidFunction
  onToggleExcludeCustomerId: VoidFunction
}

export const InboxFilters = ({
  tagger,
  batchSize,
  documentsCount,
  taggerFiltered,
  onAssignDocumentsToTagger,
  onBatchSize,
  onTaggerFilter,
  onSetCustomerId,
  customerId,
  scancenterId,
  onSetScancenterId,
  excludeScanCenter,
  excludeCustomerId,
  onToggleExcludeScanCenter,
  onToggleExcludeCustomerId,
}: InboxFiltersProps) => {
  // local state for customerId, so that it can update immediately on user input,
  // while the parent change handler is slower/async
  const [customerIdInputValue, setCustomerIdInputValue] = useState(customerId)
  const onCustomerIdInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newCustomerId = e.target.value
    setCustomerIdInputValue(newCustomerId)
    onSetCustomerId(newCustomerId)
  }

  return (
    <Card style={{ marginBottom: 16 }}>
      <Form layout="inline" style={{ gap: 16, flexWrap: 'wrap' }}>
        <Form.Item label="Customer ID">
          <Space.Compact>
            <Select
              style={{ width: 120 }}
              onChange={onToggleExcludeCustomerId}
              value={
                excludeCustomerId
                  ? FilterOptions.NotEquals
                  : FilterOptions.Equals
              }
              options={[
                { value: FilterOptions.Equals, label: FilterOptions.Equals },
                {
                  value: FilterOptions.NotEquals,
                  label: FilterOptions.NotEquals,
                },
              ]}
            />
            <Input
              style={{ width: 240 }}
              placeholder="Customer ID"
              value={customerIdInputValue}
              onChange={onCustomerIdInputChange}
            />
          </Space.Compact>
        </Form.Item>

        <Form.Item label={i18n.t('misc.scanCenter')}>
          <Space.Compact>
            <Select
              style={{ width: 120 }}
              onChange={onToggleExcludeScanCenter}
              value={
                excludeScanCenter
                  ? FilterOptions.NotEquals
                  : FilterOptions.Equals
              }
              options={[
                { value: FilterOptions.Equals, label: FilterOptions.Equals },
                {
                  value: FilterOptions.NotEquals,
                  label: FilterOptions.NotEquals,
                },
              ]}
            />
            <Select
              style={{ width: 100 }}
              value={scancenterId}
              onChange={onSetScancenterId}
            >
              {scanCenters.map(key => (
                <Select.Option key={key}>{key}</Select.Option>
              ))}
            </Select>
          </Space.Compact>
        </Form.Item>

        <Form.Item label="Tagger">
          <Radio.Group
            defaultValue={taggerFiltered}
            buttonStyle="solid"
            onChange={e => onTaggerFilter(e.target.value)}
          >
            <Radio.Button value={true}>{tagger}</Radio.Button>
            <Radio.Button value={false}>
              {i18n.t('labels.unfiltered')}
            </Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label={i18n.t('home.assignTagger.actionButton', { num: batchSize })}
        >
          <Space.Compact>
            <InputNumber
              min={1}
              max={100}
              value={batchSize}
              disabled={!taggerFiltered}
              onChange={e => e && onBatchSize(e)}
            />
            <Button
              type="primary"
              disabled={!taggerFiltered}
              onClick={onAssignDocumentsToTagger}
            >
              {i18n.t('home.assignTagger.actionButton', { num: batchSize })}
            </Button>
          </Space.Compact>
        </Form.Item>
      </Form>

      <Flex justify="flex-end" style={{ marginTop: 8 }}>
        <span style={{ fontWeight: 600, fontSize: 14 }}>
          {i18n.t('labels.filteredCount', { num: documentsCount })}
        </span>
      </Flex>
    </Card>
  )
}
